import { packTile } from "./packTiles";
import studioTiles from "../data/studioTiles.json";

const PP = (symbol) => `https://common-static.ppgames.net/game_pic/square/200/${symbol}.png`;

const BY_NAME = {
  "sweet bonanza": PP("vs20fruitsw"),
  "gates of olympus": PP("vs20olympgate"),
  "sugar rush": PP("vs20sugarrush"),
  "starlight princess": PP("vs20starlight"),
  "big bass bonanza": PP("vs10bbbonanza"),
  "sugar rush 1000": PP("vs20sugarrushx"),
  "sweet bonanza 1000": PP("vs20fruitswx"),
  "starlight princess 1000": PP("vs20starlightx"),
  "olympus 1000": PP("vs20olympx"),
  "gates of olympus 1000": PP("vs20olympx"),
  "the dog house": PP("vs20doghouse"),
  "wisdom of athena": PP("vs20procount"),
};

function fold(value = "") {
  return String(value)
    .toLocaleLowerCase("en-US")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/['’]/g, "")
    .trim();
}

export function coverFromCatalog(name = "") {
  return BY_NAME[fold(name)] || "";
}

export function proxiedCover(url = "", width = 0, tile = false) {
  const raw = String(url || "").trim();
  if (!raw) return "";
  if (/drakon|gator\./i.test(raw)) return "";
  if (raw.startsWith("/api/games/cover/")) {
    const params = new URLSearchParams();
    if (Number(width) >= 200) params.set("w", String(Math.round(Number(width))));
    if (tile) params.set("fit", "tile");
    const query = params.toString();
    return `${raw.split("?")[0]}${query ? `?${query}` : ""}`;
  }
  if (raw.startsWith("/") && !raw.startsWith("//")) return raw;
  return "";
}

export function resolveGameCover(game = {}, width = 0, tile = false) {
  const id = String(game.game_id || game.game_code || "");
  if (studioTiles[id]) return studioTiles[id];
  const banner = String(game.banner || "").trim();
  if (banner.startsWith("/tiles/studio")) return banner;
  const packed = packTile(game.game_name || game.name || "");
  if (packed) return packed;
  if (banner.startsWith("/tiles/")) return banner;
  if (/^https?:\/\//i.test(banner) || (banner.startsWith("/") && !banner.startsWith("//"))) {
    return proxiedCover(banner, width, tile) || banner;
  }
  return proxiedCover(coverFromCatalog(game.game_name || game.name || ""), width, tile);
}
